/** Navigation structure of the app shell (sidebar, phone tab bar and "Meer" sheet). */
import { CalendarDays, ChartGantt, FolderKanban, Grid3x3, HardHat, Settings, Shield, Users, type LucideIcon } from 'lucide-react';
import type { Role } from '../../shared/api.js';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  /** Minimum role; default viewer. */
  role?: Role;
}

export const NAV_ITEMS: readonly NavItem[] = [
  { to: '/mijn', label: 'Mijn planning', icon: CalendarDays },
  { to: '/projecten', label: 'Projecten', icon: FolderKanban },
  { to: '/gantt', label: 'Gantt', icon: ChartGantt },
  { to: '/team', label: 'Team', icon: Users },
  { to: '/bezetting', label: 'Bezetting', icon: Grid3x3 },
  { to: '/resources', label: 'Resources', icon: HardHat },
  { to: '/beheer', label: 'Beheer', icon: Shield, role: 'admin' },
  { to: '/instellingen', label: 'Instellingen', icon: Settings },
];

/** Phone tab bar: the three most used pages; everything else is under "Meer". */
export const TAB_PATHS: readonly string[] = ['/mijn', '/projecten', '/team'];

export function navItem(to: string): NavItem {
  return NAV_ITEMS.find((i) => i.to === to)!;
}
